import { createSelector } from "reselect"

const getContracts = (state: Contracts.Contracts): Contracts.Contract[] =>
    state.contracts

export interface SortedContracts {
    sortedContracts: Contracts.Contract[]
}

export const getSortedContracts = createSelector(
    [getContracts],
    (contracts): Contracts.Contract[] =>
        contracts.sort((a, b) => a.name.localeCompare(b.name)),
)
